import { Container, withStyles } from '@material-ui/core';

const PrimaryContainer = withStyles({
  root: {
    background: 'white',
    width: '85%',
    maxWidth: '100%',
    minHeight: '80%',
    marginTop: '7.5%',
    marginBottom: '5%',
    paddingBottom: 15,
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
})(Container);

export default PrimaryContainer;
